<template>
	<div v-loading="loading" class="main_bg" element-loading-text="加载中...">
		<div v-if="editForm.orderType === 2" class="item_info">
			<div class="item_title title_border">
				<div class="title">售后订单</div>
			</div>
			<el-descriptions class="margin-top" :column="3" border>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-tickets"></i>
						原因类型
					</template>
					{{ afterSaleReasonTypeStr }}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-tickets"></i>
						具体原因
					</template>
					{{ editForm.afterSaleReasonItem || "-" }}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-tickets"></i>
						原因说明
					</template>
					{{ editForm.afterSaleReason || "-" }}
				</el-descriptions-item>
			</el-descriptions>
		</div>
		<div class="item_info">
			<div class="item_title title_border_warning">
				<div class="title">订单信息</div>
				<div v-if="showRecordToggle" class="btnDiv record-toggle">
					<span class="record-switch">操作记录<el-switch :value="opLogVisible" @change="handleOpLogChange" active-color="#13ce66" inactive-color="#dcdfe6"></el-switch></span>
					<span class="record-switch">出库记录<el-switch :value="outputVisible" @change="handleOutputChange" active-color="#13ce66" inactive-color="#dcdfe6"></el-switch></span>
				</div>
			</div>
			<el-descriptions class="margin-top" :column="3" border>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-mobile-phone"></i>
						订单号
					</template>
					{{ editForm.orderNo }}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-user"></i>
						所属门店
					</template>
					<span style="width: 140px; display: inline-block">{{ editForm.belongStoreName }}</span>
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-location-outline"></i>
						订单时间
					</template>
					{{ editForm.orderDate }}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-tickets"></i>
						门店快递单号
					</template>
					{{ editForm.storeKDNo }}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-tickets"></i>
						加工部快递单号
					</template>
					{{ editForm.jgbkdNo }}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-tickets"></i>
						订单状态
					</template>
					{{ editForm.stateStr }}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-tickets"></i>
						取镜时间
					</template>
					{{ editForm.getOrderDate }}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-tickets"></i>
						验光师
					</template>
					{{ editForm.yanGuangShi }}
				</el-descriptions-item>

				<el-descriptions-item span="2">
					<template slot="label">
						<i class="el-icon-tickets"></i>
						镜架信息
					</template>
					{{ editForm.jjInformation }}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-tickets"></i>
						加工类型
					</template>
					{{ editForm.machinTypeStr }}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-tickets"></i>
						确认人
					</template>
					{{ editForm.confirmUserName }}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-tickets"></i>
						确认时间
					</template>
					{{ editForm.confirmTime }}
				</el-descriptions-item>
				<el-descriptions-item v-if="isShowWarehouseQty">
					<template slot="label">
						<i class="el-icon-tickets"></i>
						审核类型
					</template>
					{{ editForm.auditTypeStr }}
				</el-descriptions-item>
				<el-descriptions-item v-if="isShowWarehouseQty">
					<template slot="label">
						<i class="el-icon-tickets"></i>
						审核人
					</template>
					{{ editForm.auditUserName }}
				</el-descriptions-item>
				<el-descriptions-item v-if="isShowWarehouseQty">
					<template slot="label">
						<i class="el-icon-tickets"></i>
						审核时间
					</template>
					{{ editForm.auditTime }}
				</el-descriptions-item>
				<el-descriptions-item span="3">
					<template slot="label">
						<i class="el-icon-tickets"></i>
						备注
					</template>
					{{ editForm.remark }}
				</el-descriptions-item>
			</el-descriptions>
		</div>
		<div class="item_info">
			<div class="item_title title_border">
				<div class="title">顾客信息</div>
			</div>
			<el-descriptions class="margin-top" :column="6" border>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-user"></i>
						顾客姓名
					</template>
					<span style="width: 50px; display: inline-block">{{ transformEmpty(customerInfo.name) }}</span>
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-office-building"></i>
						性别
					</template>
					<span style="width: 40px; display: inline-block">{{ transformGender(customerInfo.gender) }}</span>
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-tickets"></i>
						年龄
					</template>
					<span style="width: 40px; display: inline-block">{{ transformEmpty(customerInfo.age) }}</span>
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-mobile-phone"></i>
						顾客电话
					</template>
					{{ transformEmpty(customerInfo.phone) }}
				</el-descriptions-item>
				<el-descriptions-item span="3">
					<template slot="label">
						<i class="el-icon-location-outline"></i>
						所属门店
					</template>
					{{ transformEmpty(customerInfo.belongStoreName) }}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-tickets"></i>
						(右眼)球镜
					</template>
					{{ transformEmpty(customerInfo.rParams.qiuJing) }}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-tickets"></i>
						柱镜
					</template>
					{{ transformEmpty(customerInfo.rParams.zhuJing) }}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-tickets"></i>
						轴位
					</template>
					{{ transformEmpty(customerInfo.rParams.zhouWei) }}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-tickets"></i>
						瞳高
					</template>
					{{ transformEmpty(customerInfo.rParams.tongGao) }}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-tickets"></i>
						瞳距
					</template>
					<span style="width: 40px; display: inline-block">{{ transformEmpty(customerInfo.rParams.tongJu) }}</span>
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-tickets"></i>
						矫正视力
					</template>
					<span style="width: 40px; display: inline-block">{{ transformEmpty(customerInfo.rParams.jiaoZhengShiLi) }}</span>
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-tickets"></i>
						(左眼)球镜
					</template>
					{{ transformEmpty(customerInfo.lParams.qiuJing) }}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-tickets"></i>
						柱镜
					</template>
					{{ transformEmpty(customerInfo.lParams.zhuJing) }}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-tickets"></i>
						轴位
					</template>
					{{ transformEmpty(customerInfo.lParams.zhouWei) }}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-tickets"></i>
						瞳高
					</template>
					{{ transformEmpty(customerInfo.lParams.tongGao) }}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-tickets"></i>
						瞳距
					</template>
					{{ transformEmpty(customerInfo.lParams.tongJu) }}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-tickets"></i>
						矫正视力
					</template>
					{{ transformEmpty(customerInfo.lParams.jiaoZhengShiLi) }}
				</el-descriptions-item>
			</el-descriptions>
		</div>
		<div class="item_info">
			<div class="item_title title_border_green">
				<div class="title">商品信息</div>
				<div v-if="!isShowWarehouseQty" class="btnDiv">
					<div class="btnDivItem">订单来源：{{ editForm.orderSourceStr }}</div>
					|
					<div class="btnDivItem">镜片类型：{{ editForm.eyeGlassTypeStr }}</div>
					|
					<div class="btnDivItem">订单类型：{{ editForm.orderTypeStr }}</div>
				</div>
				<div v-if="isShowWarehouseQty" class="btnDiv">
					<div class="btnDivItem">加工渠道：{{ editForm.machinChannelStr }}</div>
					|
					<div class="btnDivItem">镜片类型：{{ editForm.eyeGlassTypeStr }}</div>
					|
					<div class="btnDivItem">订单类型：{{ editForm.orderTypeStr }}</div>
				</div>
			</div>
			<div class="table-scroll-wrapper">
				<el-table class="lcsj-data-table" :cell-class-name="$moneyCellClass" :data="goodsTableData" border stripe style="border-radius: 10px" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }">
					<el-table-column prop="rowNumber" label="序号" width="60"></el-table-column>
					<el-table-column prop="lr" label="左右眼" width="100">
						<template slot-scope="scope">
							<el-select v-model.number="scope.row.lr" placeholder="请选择" size="small" disabled>
								<el-option key="0" label="右眼" :value="0"></el-option>
								<el-option key="1" label="左眼" :value="1"></el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column prop="goodsInfo.type" label="商品品牌" width="120"></el-table-column>
					<el-table-column prop="goodsInfo.name" label="商品名称"></el-table-column>
					<el-table-column prop="goodsInfo.qiuJing" label="球镜" width="90"></el-table-column>
					<el-table-column prop="goodsInfo.zhuJing" label="柱镜" width="90"></el-table-column>
					<el-table-column prop="zhouWei" label="轴位" width="120"></el-table-column>
					<!-- <el-table-column prop="price" label="单价" width="80">
        </el-table-column> -->
					<el-table-column prop="quantity" label="数量" width="60"></el-table-column>
					<el-table-column prop="goodsInfo.unit" label="单位" width="60"></el-table-column>
					<!-- <el-table-column prop="money" label="总价" width="80">
        </el-table-column> -->
					<el-table-column v-if="isShowWarehouseQty" prop="wareHouseQuantity" label="库存数量" width="100">
						<template slot-scope="scope">
							<span v-if="scope.row.wareHouseQuantity >= scope.row.quantity">{{ scope.row.wareHouseQuantity }}</span>
							<span v-else style="display: block; background-color: #ff0000">{{ scope.row.wareHouseQuantity }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="remark" label="ADD"></el-table-column>
				</el-table>
			</div>
		</div>
	</div>
</template>
<script>
import { GetStoreOrderDetail } from "@/api/storeOrderApi.js";

export default {
	props: {
		detailRow: {
			type: Object,
			default: null
		},
		detailType: {
			type: Number,
			default: 1
		},
		isShowWarehouseQty: {
			type: Boolean,
			default: false
		},
		// 是否显示「操作记录/出库记录」显示开关（仅加工部订单详情传 true，其他页面不受影响）
		showRecordToggle: {
			type: Boolean,
			default: false
		},
		// 操作记录开关状态（由父组件持有，受控组件模式）
		opLogVisible: {
			type: Boolean,
			default: false
		},
		// 出库记录开关状态（由父组件持有，受控组件模式）
		outputVisible: {
			type: Boolean,
			default: false
		}
	},
	emits: ["op-log-change", "output-change"],
	watch: {
		detailRow: {
			handler(val) {
				if (val) {
					this.getDetailDialog(val, this.isShowWarehouseQty, this.detailType);
				}
			},
			immediate: false
		}
	},
	data() {
		return {
			loading: false,
			saveloading: false,
			editForm: {
				belongStoreKeyId: "",
				belongStoreName: "",
				orderNo: "",
				getOrderDate: "",
				jjInformation: "",
				customerKeyId: "",
				yanGuangShi: "",
				state: 0,
				stateStr: "",
				storeKDNo: "",
				jgbkdNo: "",
				orderDate: "",
				machinType: 1,
				machinTypeStr: "",
				auditType: 0,
				auditTypeStr: "",
				remark: "",
				eyeGlassType: 0,
				eyeGlassTypeStr: "",
				orderType: 0,
				afterSaleReason: "",
				afterSaleReasonType: 0,
				afterSaleReasonItem: "",
				confirmUserName: "",
				confirmTime: "",
				orderSourceStr: "",
				orderTypeStr: "",
				machinChannelStr: ""
			},
			rules: {},
			customerInfo: {
				name: "",
				phone: "",
				age: "",
				gender: -1,
				belongStoreName: "",
				lParams: {
					qiuJing: "",
					zhuJing: "",
					zhouWei: "",
					jiaoZhengShiLi: "",
					tongJu: "",
					tongGao: ""
				},
				rParams: {
					qiuJing: "",
					zhuJing: "",
					zhouWei: "",
					jiaoZhengShiLi: "",
					tongJu: "",
					tongGao: ""
				}
			},
			goodsTableData: [],
			goodsIndex: 1,
			isAuditPass: true,
		};
	},
	computed: {
		// 售后原因类型展示（0 未区分 / 1 门店原因 / 2 加工原因，历史数据可能为 0）
		afterSaleReasonTypeStr() {
			const typeMap = { 0: "未区分", 1: "门店原因", 2: "加工原因" };
			return typeMap[this.editForm.afterSaleReasonType] || "未区分";
		}
	},
	components: {},
	created() {},
	methods: {
		// 显示
		async getDetailDialog(row, isShowWarehouseQty = false, type = 1) {
			this.isAuditPass = true;
			this.loading = true;
			this.resetData();
			const orderKeyId = type == 1 ? row.keyId : row.linkOrderKeyId;
			try {
				const orderRes = await GetStoreOrderDetail({ keyId: orderKeyId });
				if (orderRes.code == 1) {
					this.goodsIndex = 1;
					this.editForm = orderRes.data;
					this.goodsTableData = orderRes.data.dtls || [];
					this.goodsTableData.forEach((item) => {
						item.rowNumber = this.goodsIndex++;
						if (item.wareHouseQuantity < item.quantity) {
							this.isAuditPass = false;
						}
					});
					if (orderRes.data.customerInfo) {
						this.customerInfo = this.normalizeCustomerInfo(orderRes.data.customerInfo);
					}
				} else {
					this.$message({ type: "error", message: orderRes.msg });
				}
			} catch (err) {
				this.$message({ type: "error", message: "获取订单详情失败" });
			} finally {
				this.loading = false;
			}
		},
		// 重置展示数据（打开弹窗/切换数据时清空旧内容）
		resetData() {
			this.editForm = {
				belongStoreKeyId: "",
				belongStoreName: "",
				orderNo: "",
				getOrderDate: "",
				jjInformation: "",
				customerKeyId: "",
				yanGuangShi: "",
				state: 0,
				stateStr: "",
				storeKDNo: "",
				jgbkdNo: "",
				orderDate: "",
				machinType: 1,
				machinTypeStr: "",
				auditType: 0,
				auditTypeStr: "",
				remark: "",
				eyeGlassType: 0,
				eyeGlassTypeStr: "",
				orderType: 0,
				afterSaleReason: "",
				afterSaleReasonType: 0,
				afterSaleReasonItem: "",
				confirmUserName: "",
				confirmTime: "",
				orderSourceStr: "",
				orderTypeStr: "",
				machinChannelStr: ""
			};
			this.goodsTableData = [];
			this.customerInfo = this.buildEmptyCustomerInfo();
		},
		// 构造空的顾客信息（含 lParams/rParams 默认对象，避免模板访问 null 报错）
		buildEmptyCustomerInfo() {
			return {
				name: "",
				phone: "",
				age: "",
				gender: -1,
				belongStoreName: "",
				lParams: { qiuJing: "", zhuJing: "", zhouWei: "", jiaoZhengShiLi: "", tongJu: "", tongGao: "" },
				rParams: { qiuJing: "", zhuJing: "", zhouWei: "", jiaoZhengShiLi: "", tongJu: "", tongGao: "" }
			};
		},
		// 归一化后端返回的顾客信息：lParams/rParams 可能为 null，需回填默认对象
		normalizeCustomerInfo(data) {
			const empty = this.buildEmptyCustomerInfo();
			const info = Object.assign({}, empty, data || {});
			info.lParams = Object.assign({}, empty.lParams, (data && data.lParams) || {});
			info.rParams = Object.assign({}, empty.rParams, (data && data.rParams) || {});
			return info;
		},
		//转换性别
		transformGender(gender) {
			if (gender == 1) {
				return "男";
			} else if (gender == 0) {
				return "女";
			} else {
				return "--";
			}
		},
		//判断为空则用 -- 替代
		transformEmpty(obj) {
			if (obj == "" || obj == null || obj == undefined) {
				obj = "--";
			}
			return obj;
		},
		// 操作记录开关变化
		handleOpLogChange(val) {
			this.$emit("op-log-change", val);
		},
		// 出库记录开关变化
		handleOutputChange(val) {
			this.$emit("output-change", val);
		},
		// 审核
		AuditOrer() {
			return this.isAuditPass;
		},
		// 获取加工类型

	}
};
</script>
<style scoped lang="scss">
.main_bg {
	padding: 10px;
	margin-top: -15px;
}

.item_info {
	padding: 5px 10px;
	border-radius: 5px;
	margin-bottom: 15px;
	border-bottom: 2px solid var(--app-border);
}

.title_border {
	border-left: 5px solid var(--app-primary-hover);
	padding-left: 10px;
	margin-left: -10px;
}

.title_border_warning {
	border-left: 5px solid var(--app-warning);
	padding-left: 10px;
	margin-left: -10px;
}

.title_border_green {
	border-left: 5px solid var(--app-success);
	padding-left: 10px;
	margin-left: -10px;
}

.table-scroll-wrapper {
	overflow-x: auto;
	width: 100%;
}

.item_title {
	display: flex;
	width: 100%;
	font-weight: 700;
	font-size: 1rem;
	margin-bottom: 10px;
	justify-content: space-between;

	.title {
		display: inline-block;
		unicode-bidi: isolate;
	}

	.btnDiv {
		display: block;
		unicode-bidi: isolate;
		word-break: break-all;
	}

	.btnDivItem {
		display: inline-block;
	}

	.text-red {
		display: block;
		background-color: var(--app-danger);
	}

	.record-toggle {
		display: flex;
		align-items: center;
	}

	.record-switch {
		display: inline-flex;
		align-items: center;
		margin-left: 16px;
		font-weight: 400;
		font-size: 13px;
		color: var(--app-text-secondary);
	}
}
</style>
